package org.vreo.devicehub.features.userAuthentication.presentation.register

sealed interface UserRegistrationActions {
    class OnClearError : UserRegistrationActions
    class OnBackNavigationClicked : UserRegistrationActions
    data class OnRegisterClicked(
        val callback: ((userEmail: String, validUntil: Long) -> Unit)? = null
    ) : UserRegistrationActions

    // User details update
    class OnUpdateEmail(val value: String) : UserRegistrationActions
    class OnUpdatePassword(val value: String) : UserRegistrationActions
    class OnUpdateConfirmPassword(val value: String) : UserRegistrationActions
    class OnUpdateFirstName(val value: String) : UserRegistrationActions
    class OnUpdateLastName(val value: String) : UserRegistrationActions
    class OnUpdateMobileNumber(val value: String) : UserRegistrationActions

    // Company details update
    class OnUpdateCompanyName(val value: String) : UserRegistrationActions
    class OnUpdateCompanyAddressStreet(val value: String) : UserRegistrationActions
    class OnUpdateCompanyAddressCity(val value: String) : UserRegistrationActions
    class OnUpdateCompanyAddressPostalCode(val value: String) : UserRegistrationActions
    class OnUpdateCompanyAddressCountry(val value: String) : UserRegistrationActions
}